import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';
import { SimpleBaseForm } from 'app/core/components/simple-base-form';
import { EnumService } from 'app/core/services/enum.service';
import { SideBarService } from 'app/core/services/side-bar.service';
import { LoginService } from 'app/login/services/login.service';
import { businessCategory, Language } from 'app/shared/model/enums';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { CommonService } from 'app/shared/services/common.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { setLastEmail } from 'app/shared/state/actions/user.actions';
import { Observable, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { RegisterError } from '../model/enums';
import { environment } from 'environments/environment';
declare var google: any;
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterComponent extends SimpleBaseForm implements OnInit {
  protected get form(): NgForm {
    return this.registerForm
  }
  lang = Language
  subscriptions = new Subscription();
  currentLang
  businessCategory = businessCategory;
  googleClientId: string

  constructor(private commonService: CommonService, localizationService: LocalizationService,
    private loginService: LoginService, private _enumService: EnumService, private store: Store<AppState>,
    private authService: AppAuthService, messageService: AdvMessageService,
    sideBarService: SideBarService, cdr: ChangeDetectorRef, route: ActivatedRoute, router: Router,) {
    super(messageService, localizationService, route, sideBarService, cdr, router);
    this.subscriptions.add(store.select(selectLanguageInCommonState).subscribe(language => {
      this.currentLang = language;
      this.registerModel.language = this.currentLang
      this.loadCountriesAndCities();
    }));
  }

  @ViewChild("registerForm") registerForm: NgForm;
  displayWebGameAgreement
  registerModel = {
    businessName: '', country: '', city: '', address: '', phone: '', category: '', details: "", ownerFullName: '', language: null,
    Agreemant: false, email: '', password: '', webSite: ''
  };
  confirmPassword: string;
  cities
  allCities
  countries
  allCountries
  categories
  AgreementUrl: string
  languages
  allCategories
  selectedCategory: { value: any; }
  @Output() registerSucceeded: EventEmitter<boolean> = new EventEmitter<boolean>();
  public save(args?: any): Observable<any> {    
    return this.authService.register(this.registerModel)
      .pipe(map(res => {
        if (res.Error) {
          switch (res.Error) {
            case RegisterError.EmailAlreadyExist:
              this.messageService.errorMessage('REGISTER.EMAIL_EXIST', true);

              break;
            default:
              this.messageService.errorMessage('REGISTER.UNKNOWN_ERROR', true);
              break;
          }
          return null
        }
        else {
          this.store.dispatch(setLastEmail({ email: this.registerModel.email }));
          this.localizationService.changeLanguage(this.registerModel.language)
          if (this.registerSucceeded) {
            this.registerSucceeded.emit(true);
          }
        }
      })
      )
  }

  ngOnInit(): void {
    this.loadCategories()
    this.languages = this._enumService.getEnumValues(this.lang);
    this.getAgreementurl()
    this.googleClientId = environment.clientId
    this.registerWithGoogle()
  }
  loadCountriesAndCities() {
    if (this.currentLang != Language.he) {
      this.allCountries = [];
      this.allCities = [];
    } else {
      this.commonService.getCountriesList().subscribe((res: any) => {
        this.allCountries = res.result.records.map(c => c['שם_ארץ'].trim());
      });
      this.commonService.getIsraelCities().subscribe((res: any) => {
        this.allCities = res.map(c => c.name.trim())
      });
    }
  }
  getAgreementurl() {
    this.loginService.AgreementUrl(this.currentLang).subscribe((res: any) => {
      this.AgreementUrl = res.agreementUrl;
    })
  }
  checkPasswordMatch() {
    if (this.registerModel.password !== this.confirmPassword) {
      this.registerForm.controls['confirm_password'].setErrors({ 'mustMatch': true });
    } else {
      this.registerForm.controls['confirm_password'].clearValidators();
    }
  }
  registerWhithFaisebook() {

  }
  displayAgreement() {
    this.displayWebGameAgreement = true
  }
  filterCities(event: any) {
    if (this.currentLang != Language.he || this.registerModel.country != 'ישראל') {
      this.cities = []
      this.form.form.markAsDirty()
    }
    else {
      if (this.allCities.find(x => x === event.query) && event.originalEvent.type == 'click') {
        this.cities = [...this.allCities];
        this.markAsDirty()

      }
      else {
        this.cities = [...this.allCities.filter(x => x.includes(event.query))];
      }
    }
  }
  filterCountries(event: any) {

    if (this.allCountries.find(x => x == event.query) && event.originalEvent.type == 'click') {
      this.countries = [...this.allCountries];
    }
    else {
      this.countries = [...this.allCountries.filter(x => x.includes(event.query))];
    }

  }
  loadCategories(): void {
    this.loginService.getCategoriesTypes(this.currentLang).subscribe((res: any) => {
      if (res.Category) {
        this.allCategories = res.Category.map(category => { return { label: category.Description, value: category.Id } });
        const otherCategory = this.allCategories.find(c => c.value == this.businessCategory.other);
        if (otherCategory) {
          this.allCategories = [...this.allCategories.filter(c => c.value != this.businessCategory.other), otherCategory];
        }
      }
    })
  }
  selectCategory() {
    this.registerModel.category = this.selectedCategory?.value;
    this.loadCategories()
  }

  filterCategories(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    if (this.allCategories) {
      this.categories = [...this.allCategories.filter(x => x.includes(event.query))];
    }
  }

  agreeTerms() {
    this.displayWebGameAgreement = false;
    this.registerModel.Agreemant = true;
  }
  close() {
    this.displayWebGameAgreement = false
  }
  registerWithGoogle() {
    setTimeout(() => {
      google.accounts.id.initialize({
        client_id: this.googleClientId,
        callback: (response) => {
          if(this.isValid())
          {
            this.authService.registerByGoogle(response.credential, this.registerModel).subscribe(
              (res) => {
                if (res.Error) {
                  switch (res.Error) {
                    case RegisterError.EmailAlreadyExist:
                      this.messageService.errorMessage('REGISTER.EMAIL_EXIST', true);
                      break;
                    default:
                      this.messageService.errorMessage('REGISTER.UNKNOWN_ERROR', true);
                      break;
                  }
                  return null
                }
                else {
                  this.store.dispatch(setLastEmail({ email: this.registerModel.email }));
                  this.localizationService.changeLanguage(this.registerModel.language)
                  if (this.registerSucceeded) {
                    this.registerSucceeded.emit(true);
                  }
                }
              }
            );
          }
          else{
            this.messageService.errorMessage('ERRORS.CANNOT_SAVE_INVALID_FORM', true)
              return;
          }
        }})
      google.accounts.id.renderButton(
        document.getElementById('googleRegisterButton'), // parent element
        {
          theme: 'outline',
          size: 'x-large',
          text: 'signup_with',
          shape: 'rectangular',
          type: 'standard',
          width:'400px',
          class:'.disabled?this.registerForm.invalid'
        }
        
      );
    }, 500)
  }
 
  sendRegisterForm()
  {    
    this.registerForm.controls['email'].setValidators([Validators.required,Validators.email])
    this.registerForm.controls['password'].setValidators([Validators.required])
      this.checkPasswordMatch()
      this.registerForm.controls['email'].updateValueAndValidity();
      this.registerForm.controls['password'].updateValueAndValidity();
      this.saveForm()
  }
  registerByGoogle()
  {
    this.isValid()
    this.registerForm.controls['email'].clearValidators()
    this.registerForm.controls['password'].clearValidators()
    this.registerForm.controls['confirm_password'].clearValidators();
   
    this.registerForm.controls['email'].updateValueAndValidity();
      this.registerForm.controls['password'].updateValueAndValidity();
      this.registerForm.controls['confirm_password'].updateValueAndValidity();
  }
}
